var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1101 2.79581C15.5684 3.69525 15.5684 4.87267 15.5684 7.22752V9.49706C15.5684 9.73227 15.5684 9.84983 15.5637 9.94914C15.4612 12.1151 13.7285 13.8478 11.5625 13.9503C11.4632 13.955 11.332 13.955 11.0698 13.955L11.0024 13.9551C10.1445 13.9606 9.30866 14.2284 8.60735 14.7227L8.56276 14.7544L6.36728 16.3226C5.61466 16.8602 4.62565 16.0838 4.96915 15.2251C5.21248 14.6168 4.76447 13.955 4.1093 13.955H3.60326C1.85156 13.955 0.431519 12.535 0.431519 10.7833V7.22752C0.431519 4.87267 0.431519 3.69525 0.889803 2.79581C1.29292 2.00464 1.93616 1.3614 2.72733 0.958285C3.62677 0.5 4.80419 0.5 7.15904 0.5H8.84092C11.1958 0.5 12.3732 0.5 13.2727 0.958285C14.0638 1.3614 14.7071 2.00464 15.1101 2.79581ZM5.47716 7.22752C5.47716 7.69196 5.10066 8.06846 4.63622 8.06846C4.17179 8.06846 3.79528 7.69196 3.79528 7.22752C3.79528 6.76309 4.17179 6.38658 4.63622 6.38658C5.10066 6.38658 5.47716 6.76309 5.47716 7.22752ZM8.84092 7.22752C8.84092 7.69196 8.46442 8.06846 7.99998 8.06846C7.53555 8.06846 7.15904 7.69196 7.15904 7.22752C7.15904 6.76309 7.53555 6.38658 7.99998 6.38658C8.46442 6.38658 8.84092 6.76309 8.84092 7.22752ZM11.3637 8.06846C11.8282 8.06846 12.2047 7.69196 12.2047 7.22752C12.2047 6.76309 11.8282 6.38658 11.3637 6.38658C10.8993 6.38658 10.5228 6.76309 10.5228 7.22752C10.5228 7.69196 10.8993 8.06846 11.3637 8.06846Z",
    fill: "#58A493"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/addComment.584b952891775706d641f7025e5d2e78.svg";
export { ForwardRef as ReactComponent };